import request from '@/utils/request'

export function Login(code){
  return request({
    url: 'wx/login',
    method: 'post',
    params: {code:code}
  })
}

export function GetAccess(){
  return request({
    url: 'access',
    method: 'get'
  })
}

export function JaccountLogin(data){
  return request({
    url: 'jaccount/login',
    method: 'post',
    data
  })
}

export function GetUserInfo(){
  return request({
    url: 'wx/user',
    method: 'get'
  })
}

export function GetPhoneCode(phone){
  return request({
    url: 'wx/code/'+phone,
    method: 'get'
  })
}

export function PostPhoneCode(data){
  return request({
    url: 'wx/verify-code',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js


// WEBPACK FOOTER //
// ./src/api/app.js